import { Fragment } from 'react';

import useAthleteEntryContextView from './UseAthleteEntryContextView';

import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import PageNotFound from '@usas/ui-web/components/PageNotFound';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AthleteEntryContextView = ({ children }) => {
  const {
    omeMeetOrgUnitAthleteEntryIndividualRosterEntryState,
    backToLabel,
    onBackClicked
  } = useAthleteEntryContextView();

  if (!omeMeetOrgUnitAthleteEntryIndividualRosterEntryState || Object.keys(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData).length === 0) {
    return (
      <Fragment>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackClicked}>
              <LeftArrowIcon />  {backToLabel}
            </button>
          </div>
        </div>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PageNotFound />
          </div>
        </div>
      </Fragment>
    )
  }

  return (
    <Fragment>
      {children}
    </Fragment >
  );
};

export default AthleteEntryContextView;